import Layout from '@/gf/components/Layout'
import Spinner from '@/gf/components/Spinner'
import UserM from '@/gf/modules/User'
import { FetchConversationsQueryResult } from '@/suppliers/_gen/gql'
import useSession from '@/suppliers/hooks/useSession'
import { ApolloError } from '@apollo/client'
import { useNavigate, useParams } from 'react-router-dom'
import AdminStoreOrderInbox from '../../components/AdminStoreOrderInbox'
import StoreOrderInbox from '../../components/StoreOrderInbox'
import { useOrderContext } from './context'

const Messages = ({
  conversationsData,
  conversationsError,
  conversationsRefetch,
  page,
  setPage,
}: {
  conversationsData: NonNullable<FetchConversationsQueryResult>['data']
  conversationsError: ApolloError | undefined
  conversationsRefetch: () => Promise<unknown>
  page: number
  setPage: (page: number) => void
}) => {
  const { user } = useSession()
  const { storeOrderOld, storeOrder } = useOrderContext()
  const { conversationId } = useParams()
  const navigate = useNavigate()

  const onSelectedConversationIdChange = (selectedConversationId: string | undefined) =>
    selectedConversationId
      ? navigate(`/orders/${storeOrderOld.id}/messages/${selectedConversationId}`)
      : navigate(`/orders/${storeOrderOld.id}/messages`)

  return (
    <div className="-mt-2 flex grow">
      {conversationsError ? (
        <Layout.FullPageLayout>
          <p className="text-sm text-gray-700">{conversationsError.message}</p>
        </Layout.FullPageLayout>
      ) : !conversationsData ? (
        <Layout.FullPageLayout>
          <Spinner className="mt-4" />
        </Layout.FullPageLayout>
      ) : UserM.isAdmin(user) ? (
        <AdminStoreOrderInbox
          conversations={conversationsData.fetchConversations.conversations}
          refetchConversations={conversationsRefetch}
          page={page}
          setPage={setPage}
          pagination={conversationsData.fetchConversations.pagination}
          user={user}
          storeOrder={{ ...storeOrderOld, company: storeOrder.company }}
          selectedConversationId={conversationId}
          onSelectedConversationIdChange={onSelectedConversationIdChange}
        />
      ) : (
        <StoreOrderInbox
          conversations={conversationsData.fetchConversations.conversations}
          refetchConversations={conversationsRefetch}
          page={page}
          setPage={setPage}
          pagination={conversationsData.fetchConversations.pagination}
          user={user}
          storeOrder={{ ...storeOrderOld, company: storeOrder.company }}
          selectedConversationId={conversationId}
          onSelectedConversationIdChange={onSelectedConversationIdChange}
        />
      )}
    </div>
  )
}

export default Messages
